<div
  class="loading-container"
  [class.loading-blocked]="loadingStore.isPageLoading()">
  <ng-content></ng-content>
  @if(loadingStore.isPageLoading()){
  <div class="loading-overlay">
    <p-progressSpinner class="loading-spinner"></p-progressSpinner>
  </div>
  }
</div>
